<template>
    <div>
        <div class="group" v-loading="dataLoading1">
            <div class="page-group-title"><span>销售信息</span></div>
            <table  v-if="data && data1" class="info-table MT20" style="width:100%">
                <tr>
                    <th>结款方ID</th>
                    <td>{{ data1.applyUserId }}</td>
                    <th>结款方名称</th>
                    <td>{{ data1.applyUserName }}</td>
                </tr>
                <tr>
                    <th>销售截止时间</th>
                    <td>{{ data1.applyEndTime }}</td>
                    <th>结款单状态</th>
                    <td>
                        <span v-if="data.status == 1" class="color-danger">待结款</span>
                        <span v-else-if="data.status == 2">已结款</span>
                        <span v-else class="color-info">已拒绝</span>
                    </td>
                </tr>
                <tr>
                    <th>销售商品数</th>
                    <td>{{ data1.saleNum }}</td>
                    <th>销售金额<span class="color-info font10">(由收入扣除未结算且待退款和已退款的金额而来)</span></th>
                    <td class="color-danger">{{ data1.saleAmountFormat }}</td>
                </tr>
                <tr>
                    <th>商家承担优惠</th>
                    <td>{{ data1.busDiscountFormat }}</td>
                    <th>服务费用</th>
                    <td class="color-danger">{{ data1.serviceFeeAmountFormat }}</td>
                </tr>
                <tr>
                    <th>已结算商品退款数</th>
                    <td>{{ data1.refundNum || 0}}</td>
                    <th>已结算商品退款金额<span class="color-info font10">(将返回之前结算时扣除的服务费)</span></th>
                    <td class="color-danger">{{data1.refundAmountStr || 0}} - {{data1.refundAmountServiceStr || 0}} = {{ data1.refundAmountFinalStr || 0}}</td>
                </tr>
                <tr>
                    <th>预计结款</th>
                    <td colspan="3" class="color-danger">
                        {{ data1.saleAmountFormat }} - {{ data1.busDiscountFormat }} - {{ data1.serviceFeeAmountFormat }} - {{ data1.refundAmountFinalStr || 0}} =
                        {{ data1.proposeAmountFormat }}
                        <p class="color-info">销售金额 - 商家承担优惠 - 服务费用 - 已结算商品退款金额<span class="font10">(将返回之前结算时扣除的服务费)</span></p>
                    </td>
                </tr>
            </table>
        </div>
        <div class="group MT20">
            <div class="page-group-title"><span>已结算退款</span></div>
             <el-table
                :data="data2"
                border
                style="width: 100%"
                v-loading="dataLoading2"
                size="small"
                stripe
                class="MT20"
                max-height="400"
            >
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="name" label="名称" min-width="120" show-overflow-tooltip></el-table-column>
				<el-table-column prop="balanceType " label="结算方式" min-width="120" show-overflow-tooltip>
					<template slot-scope="scope">
					    <span v-if="scope.row.balanceType==1" >自营-预付款</span>				        
					    <span v-else-if="scope.row.balanceType==2">代销-后付款</span>
					</template>
				</el-table-column>
                <el-table-column prop="refundNum" label="退款数"></el-table-column>
                <el-table-column prop="refundAmount" label="退款金额"></el-table-column>
                <el-table-column prop="serviceFee" label="服务费率">
                    <template slot-scope="scope">{{scope.row.serviceFee}}%</template>
                </el-table-column>
            </el-table>
        </div>
        <div class="group MT20">
            <div class="page-group-title"><span>商品销售</span></div>
             <el-table
                :data="data3"
                border
                style="width: 100%"
                v-loading="dataLoading3"
                size="small"
                stripe
                class="MT20"
                max-height="400"
            >
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="name" label="名称" min-width="120" show-overflow-tooltip></el-table-column>
				<el-table-column prop="balanceType " label="结算方式" min-width="120" show-overflow-tooltip>
					<template slot-scope="scope">
					    <span v-if="scope.row.balanceType==1" >自营-预付款</span>				        
					    <span v-else-if="scope.row.balanceType==2">代销-后付款</span>
					</template>
				</el-table-column>
                <el-table-column prop="saleNum" label="销售数"></el-table-column>
                <el-table-column prop="saleAmountFormat" label="销售金额"></el-table-column>
                <el-table-column prop="serviceFee" label="服务费率">
                    <template slot-scope="scope">{{scope.row.serviceFee}}%</template>
                </el-table-column>
            </el-table>
        </div>

       <div class="group MT20">
            <el-button @click="goBack">返回</el-button>
            <el-button v-if="$utils.have('/goodsReceivablesAudit/audi/excel')"  type="primary" icon="el-icon-download" @click="download" :loading="downLoading">导出明细</el-button>    
        </div>
    </div>
</template>

<script>
import {downloadFileTmp} from '@/assets/js/commonApi.js';
export default {
    props:{
        id: {
            type: [Number, String],
            default: () => null
        },
        uid: {
            type: [Number, String],
            default: () => null
        },
    },
    data(){
        return{
            redirect: this.$route.query.redirect || '/finance/goods/settlement/detail',
            data: null,
            dataLoading:false,
            data1: null,
            dataLoading1:false,
            data2: null,
            dataLoading2:false,
            data3: null,
            dataLoading3:false,
            downLoading: false
        }
    },
    mounted(){
        this.getData();
        this.getData1();
        this.getData2();
        this.getData3();
    },
    methods:{
        // 获取结款信息
        getData(){
            this.dataLoading = true;
            this.$request({
                url: '/goodsReceivablesAudit/audi/get',
                params: {
                    id: this.id,
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result;
                    } else {
                        this.$message.error(msg || "获取结款信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取结款信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //获取销售信息统计
        getData1(){
            this.dataLoading1 = true;
            this.$request({
                url: '/goodsReceivablesAudit/audi/sale/statistic',
                params: {
                    id: this.id,
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data1 = result;
                    } else {
                        this.$message.error(msg || "获取销售信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取销售信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading1 = false;
                });
        },
        //获取退款统计列表
        getData2(){
            this.dataLoading2 = true;
            this.$request({
                url: '/goodsReceivablesAudit/audi/spu/refund/statistic',
                params: {
                    id: this.id,
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data2 = result || [];
                    } else {
                        this.$message.error(msg || "获取已结算退款统计失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取已结算退款统计失败,请重试");
                })
                .finally(() => {
                    this.dataLoading2 = false;
                });
        },
        //获取商品销售统计列表
        getData3(){
            this.dataLoading3 = true;
            this.$request({
                url: '/goodsReceivablesAudit/audi/spu/sale/statistic',
                params: {
                    id: this.id,
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data3 = result || [];
                    } else {
                        this.$message.error(msg || "获取商品销售统计失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取商品销售统计失败,请重试");
                })
                .finally(() => {
                    this.dataLoading3 = false;
                });
        },
        //导出费用明细
        async download(){
            let filePath, fileName;
            this.downLoading = true;
            const res = await this.$request({
                url:'/goodsReceivablesAudit/audi/excel',
                method: 'post',
                params: {
                    id: this.id,
                },
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result} = res.data;
            if(state == 1 && result){
                filePath = result.url;
                fileName = result.fileName;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,`${fileName}.`+this.$utils.getFileType(filePath));
            this.downLoading = false;
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.el-card{
    .el-col{
        line-height: 28px;
        span{
            vertical-align: top;
        }
    }
}
.font10{
	font-size: 10px;
}
</style>